import React, { useEffect, useRef } from "react";
import { Pencil, X } from "lucide-react";
import Blog from "./Blog";

interface EditBlogModalProps {
  blogId?: string;
  isAdmin: boolean;
  onSaveSuccess?: () => void;
  setIsEdit?: (value: boolean) => void;
  isEdit?: boolean;
  onClose?: () => void;
}

const EditBlogModal: React.FC<EditBlogModalProps> = ({
  blogId,
  isAdmin,
  onSaveSuccess,
  setIsEdit,
  isEdit,
  onClose,
}) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const modalRef = useRef<HTMLDivElement>(null);

  // Close modal on escape or outside click
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsOpen(false);
    };

    const handleClickOutside = (event: MouseEvent) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.addEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.removeEventListener("mousedown", handleClickOutside);
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  if (!isAdmin) {
    return null;
  }

  const handleSaveSuccess = () => {
    setIsOpen(false);
    if (onSaveSuccess) onSaveSuccess();
  };

  return (
    <>
      <button
        onClick={() => {
          setIsOpen(true);
          setIsEdit?.(false);
        }}
        className="btnPrimary iconBtn"
      >
        <Pencil size={20} />
      </button>
      {isOpen && (
        <div className="popupWrapper">
          <div ref={modalRef} className="popupContBlkBig">
            <div className="popupHeadingBlk">
              <h4>Edit Article</h4>
              <div>Make changes to the article below.</div>
              <button
                onClick={() => (onClose ? onClose() : setIsOpen(false))}
                className="closePopup"
              >
                <X size={20} />
              </button>
            </div>

            <div className="p-4">
              <Blog
                blogId={blogId}
                isEditable
                onSaveSuccess={handleSaveSuccess}
                setIsEdit={setIsEdit}
                isEdit={isEdit}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default EditBlogModal;
